'use strict'

/**
 *
 * @name: addonYoutube
 *
 */

import DirectiveTemplate from './nn-addon-youtube.directive.html'
import './nn-addon-youtube.directive.scss'

function AddonYoutubeDirective() {

  'ngInject'

  return {
    restrict: 'C',
    replace: true,
    scope: {
      post: '=*',
    },
    template: DirectiveTemplate,
    link: function(scope, element, attrs) {


      /*
       *
       * @CONFIG
       *
       */


      scope.youtubeSettings = {
        item: null
      }


      /*
       *
       * @PUBLIC
       *
       */


      /*
       *
       * @PRIVATE
       *
       */


       function _setSettings () {
        scope.post.media.some(function(item) {

          if (item.key === attrs.mediaKey) {

            scope.youtubeSettings.item = item
            return true
          }
          return false
        })
       }

      function _initPlayer () {
        const playerName = 'youtube-player' + scope.youtubeSettings.item.content
        new YT.Player(playerName, {
          height: '100%',
          width: '100%',
          videoId: scope.youtubeSettings.item.content,
        })
       }


      /*
       *
       * @INIT
       *
       */


      _setSettings()

      setTimeout(() => {
        _initPlayer()
      }, 500)


    }
  }
}

export default AddonYoutubeDirective



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-addon-youtube/nn-addon-youtube.directive.js